import React, { useMemo, useState } from 'react';
import { Button, Card, Typography } from 'seagull';
import ChangesApprovalInfoBox from "../../../ChangesApprovalInfoBox/ChangesApprovalInfoBox";
import { relationshipModel, timeModel } from "../../../../models";
import styles from "./ChangesSummary.module.scss";
import { getChangesSummary } from "./ChangesSummary.utils";
import { Intent } from "../../../../infra/access-control";
import { useGlobalContext, useStoreActions } from "../../../../contexts";
import { handleRequest, hasServerError } from "../../../../infra/utils";
import { ErrorText, ServerError } from "../../../../constants";
export default function ChangesSummary(props) {
  const {
    relationship,
    testid,
    isVendor,
    refresh
  } = props;
  const {
    api,
    logBI
  } = useStoreActions();
  const globalContext = useGlobalContext();
  const [isApproving, setIsApproving] = useState(false);
  const [isDeclining, setIsDeclining] = useState(false);
  const changesSummary = useMemo(() => {
    return getChangesSummary(relationship);
  }, [relationship]);

  async function approveAmendments() {
    logBI(10150);
    setIsApproving(true);
    const [, err, hasError] = await handleRequest(api.relationship.approveAllAmendments(relationship.id, relationship.version));

    if (hasError) {
      globalContext.showErrorToast(hasServerError(err, ServerError.MismatchingRelationshipVersion) ? ErrorText.MismatchingRelationshipVersion : 'Failed to approve amendments, please try again', 'approve-amendments-error');
    } else {
      await refresh({
        silent: true
      });
      globalContext.showSuccessToast('Approved amendments successfully', 'approve-amendments-success');
    }

    setIsApproving(false);
  }

  async function declineAutoApproval() {
    logBI(10151);
    setIsDeclining(true);
    const [,, hasError] = await handleRequest(api.relationship.stopAutoApproveAmendments(relationship.id));

    if (hasError) {
      globalContext.showErrorToast('Failed to decline auto-approval, please try again', 'decline-auto-approval-error');
    } else {
      await refresh({
        silent: true
      });
      globalContext.showSuccessToast('Declined auto-approval', 'decline-auto-approval-success');
    }

    setIsDeclining(false);
  }

  return changesSummary.length > 0 ? /*#__PURE__*/React.createElement(Card, {
    disableSeparator: true,
    skin: "info",
    title: /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      weight: "normal"
    }, "Changes awaiting approval"),
    padding: "m",
    "data-testid": testid,
    actions: !isVendor && /*#__PURE__*/React.createElement(React.Fragment, null, relationshipModel.hasAutoAmendments(relationship) && /*#__PURE__*/React.createElement(Button, {
      skin: "primaryOutline",
      size: "small",
      intent: Intent.DeclineAutoApproval,
      loading: isDeclining,
      "data-testid": "".concat(testid, "-decline"),
      tooltip: {
        placement: 'top',
        title: 'Disables the auto-approval of all agreement amendments'
      },
      onClick: declineAutoApproval
    }, "Decline"), /*#__PURE__*/React.createElement(Button, {
      intent: Intent.ApproveAllAmendments,
      size: "small",
      "data-testid": "".concat(testid, "-approve"),
      loading: isApproving,
      tooltip: {
        placement: 'top',
        title: 'Approves all agreement amendments'
      },
      onClick: approveAmendments
    }, "Approve"))
  }, changesSummary.map((_ref, i) => {
    let {
      autoApprovalDate,
      changes,
      amendmentDate
    } = _ref;
    return /*#__PURE__*/React.createElement("div", {
      key: i
    }, amendmentDate && /*#__PURE__*/React.createElement(Typography, {
      className: styles.amendmentDate,
      "data-testid": "".concat(testid, "-").concat(i, "-made-on")
    }, "Made on ", timeModel.formatDate(amendmentDate)), /*#__PURE__*/React.createElement("ul", {
      className: styles.changes
    }, changes.map((text, idx) => /*#__PURE__*/React.createElement(Typography, {
      as: "li",
      variant: "paragraph2",
      key: text,
      className: styles.changeItem,
      "data-testid": "".concat(testid, "-").concat(i, "-").concat(idx)
    }, text))), autoApprovalDate && /*#__PURE__*/React.createElement(ChangesApprovalInfoBox, {
      className: styles.approvalInfo,
      testid: "".concat(testid, "-").concat(i, "-approval-info"),
      autoApprovalDate: autoApprovalDate
    }));
  })) : null;
}